<template>
  <v-textarea
    class="container-comment-reply pa-0"
    background-color="transparent"
    color="#96a7af"
    dense
    dark
    outlined
    readonly
    auto-grow
    hide-details
    v-html="html"
  ></v-textarea>
</template>

<script>
import { numFormat, timeToSecond } from '@/common/lib/strLib'

export default {
  name: 'DetailHtml',
  created() {
    this.commentFilter(this.cmContent)
  },
  props: {
    cmContent: String,
    cmId: String,
  },
  data() {
    return {
      html: '',
      idList: [],
    }
  },
  beforeDestroy() {
    for (let id in this.idList) {
      if (document.getElementById(this.idList[id]) != null) {
        document.getElementById(this.idList[id]).removeEventListener('click', this.setIndexEventListener)
      }
    }
  },
  methods: {
    addTimestampClickListener() {
      setTimeout(() => {
        for (let id in this.idList) {
          if (document.getElementById(this.idList[id]) != null) {
            document.getElementById(this.idList[id]).addEventListener('click', this.setIndexEventListener)
          }
        }
      }, 100)
    },
    setIndex(sectionIndex, clipIndex, time) {
      let clipIdx = Number.parseInt(clipIndex)
      let sectionIdx = Number.parseInt(sectionIndex)

      let isRequestSetSeekTime = this.storeSectionIndex === sectionIdx && this.storeClipIndex === clipIdx

      this.$store.dispatch('changeCurrentClip', {
        clipIndex: clipIdx,
        sectionIndex: sectionIdx,
        currentClip: this.totalSectionList[sectionIdx].clipList[clipIdx],
        timeStampSeekTime: timeToSecond(time),
      })
      if (isRequestSetSeekTime) {
        let temp = this.$store.getters.isRequestSetSeekTime
        this.$store.dispatch('setIsRequestSetSeekTime', temp && temp !== null ? !temp : true)
      }
    },
    setIndexEventListener(event) {
      let app = this
      event.preventDefault()
      app.setIndex(
        event.target.attributes['sectionIndex'].nodeValue,
        event.target.attributes['clipIndex'].nodeValue,
        event.target.attributes['time'].nodeValue,
        true
      )
    },
    commentFilter(content) {
      if (!content) return ''

      let showContent = content
      let timestamp
      let link = ''
      let replaceStr = ''

      const Rexp =
        /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\\/=~_|!:,.;]*)[-A-Z0-9+&@#\\/%=~_|])/gi

      if (this.totalSectionList !== undefined && this.totalSectionList !== null) {
        // Section Meeting 댓글
        if (content.includes('stId:')) {
          timestamp = content.match(/ST:\S{36}\sclipId:CL:\S{36}\s\d{2}:\d{2}/g)
          for (let str in timestamp) {
            let strSplit = timestamp[str].replace('clipId:', '').split(' ')
            let sectionIndex = this.totalSectionList.findIndex((sectionInfo) => sectionInfo.stId === strSplit[0])

            // Section 이 없을 경우
            if (sectionIndex < 0) {
              link = '[Deleted Section' + ' ' + strSplit[2] + ']'
            } else {
              let clipList = this.totalSectionList[sectionIndex].clipList
              let clipIndex = -1
              if (clipList !== undefined && clipList !== null && clipList.length > 0)
                clipIndex = clipList.findIndex((clip) => clip.clipId === strSplit[1])

              // Clip 이 없을 경우
              if (clipIndex < 0) {
                link = '[Deleted Clip' + ' ' + strSplit[2] + ']'
              } else {
                let id = this.cmId + '_' + str
                this.idList.push(id)
                this.idList = [...new Set(this.idList)]
                link = `<a style='line-break: anywhere' time='${
                  strSplit[2]
                }' sectionIndex= '${sectionIndex}' clipIndex='${clipIndex}' id='${id}' @click='setIndex(${sectionIndex}, ${clipIndex})'>[Clip#${numFormat(
                  sectionIndex + 1
                )}-${numFormat(clipIndex + 1)} ${strSplit[2]}]</a>`
              }
            }

            replaceStr = '[stId:' + strSplit[0] + ' clipId:' + strSplit[1] + ' ' + strSplit[2] + ']'
            showContent = showContent.replace(replaceStr, link)
          }
        }
        // Chronological && 기존 댓글
        else {
          timestamp = content.match(/CL:\S{36}\s\d{2}:\d{2}/g)
          for (let str in timestamp) {
            let strSplit = timestamp[str].split(' ')

            let sectionIndex = -1

            if (this.mtInfo.mtType === 'chronological') {
              for (let section in this.totalSectionList) {
                if (this.totalSectionList[section].clipList.length > 0) {
                  let isMatched = this.totalSectionList[section].clipList[0].clipId === strSplit[0]
                  if (isMatched) {
                    sectionIndex = Number.parseInt(section)
                    break
                  }
                }
              }
            } else {
              sectionIndex = 0
            }

            // 섹션이 없을 경우
            if (sectionIndex < 0) {
              link = '[Deleted Clip' + ' ' + strSplit[1] + ']'
            } else {
              let clipList = this.totalSectionList[sectionIndex].clipList
              let clipIndex = -1
              if (clipList !== undefined && clipList !== null && clipList.length > 0)
                clipIndex = clipList.findIndex((clip) => clip.clipId === strSplit[0])
              // Clip 이 없을 경우
              if (clipIndex < 0) {
                link = '[Deleted Clip' + ' ' + strSplit[1] + ']'
              } else {
                let id = this.cmId + '_' + str
                this.idList.push(id)
                this.idList = [...new Set(this.idList)]
                link = `<a style='line-break: anywhere' time='${
                  strSplit[1]
                }' sectionIndex= '${sectionIndex}' clipIndex='${clipIndex}' id='${id}' @click='setIndex(${sectionIndex}, ${clipIndex})'>[Clip#${numFormat(
                  this.mtInfo.mtType === 'chronological' ? sectionIndex + 1 : clipIndex + 1
                )} ${strSplit[1]}]</a>`
              }
            }
            replaceStr = '[clipId:' + strSplit[0] + ' ' + strSplit[1] + ']'
            showContent = showContent.replace(replaceStr, link)
          }
        }
        if (showContent.includes('http')) {
          showContent = showContent.replace(Rexp, "<a href='$1' target='_blank'>$1</a>")
        }
        showContent = showContent.replaceAll('\n', '</br>')
        showContent = showContent.replace(/<(?!\/?br|a|\/a( |>))/g, '&lt;').replace(/(?=&lt;[^>]+)>/g, '&gt;')
        this.html = showContent
      } else this.html = ''
    },
  },
  computed: {
    totalSectionList() {
      return this.$store.getters.totalSectionList
    },
    storeClipIndex() {
      return this.$store.getters.clipIndex
    },
    storeSectionIndex() {
      return this.$store.getters.sectionIndex
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
  },
  watch: {
    cmContent: {
      handler(val) {
        this.commentFilter(val)
      },
    },
    html(val) {
      if (val && val !== null && val.includes('<a')) this.addTimestampClickListener()
    },
  },
}
</script>

<style scoped>
.container-comment-reply {
  /* line-break: anywhere; */
  /* word-break: keep-all; */
  /* word-break: break-all; */
  word-break: normal;
  overflow-wrap: anywhere;

  display: block;
  font-size: 14px;
}
</style>
